// Tasks Pro shared constants — colorful template-matching palette.

export const COLUMNS = [
  { id: "todo",         label: "To-do",       color: "#f97316" }, // orange
  { id: "yet_to_start", label: "Yet to Start", color: "#84cc16" }, // olive
  { id: "in_progress",  label: "In-Progress",  color: "#1e40af" }, // navy blue
  { id: "on_hold",      label: "On-Hold",      color: "#c026d3" }, // magenta
  { id: "completed",    label: "Completed",    color: "#15803d" }, // green
];

// Feature tiles from the template screenshot
export const FEATURE_TILES = [
  { title: "Task Planning",        color: "#22c55e", icon: "layers"    },
  { title: "Task Scheduling",      color: "#ef4444", icon: "list-ordered" },
  { title: "Priority",             color: "#6366f1", icon: "calendar-days" },
  { title: "Task Tracking",        color: "#1e40af", icon: "clipboard-check" },
  { title: "Recurring Tasks",      color: "#14b8a6", icon: "refresh-ccw" },
  { title: "Reporting and Visualization", color: "#166534", icon: "bar-chart-3" },
];

// Category tag palette shown on task cards ("BACK LOG", "DESIGN", "TESTING"...)
export const CATEGORY_TAGS = [
  { label: "BACK LOG", color: "#ec4899" }, // pink
  { label: "DESIGN",   color: "#8b5cf6" }, // purple
  { label: "TESTING",  color: "#f97316" }, // orange
  { label: "HIGH",     color: "#ef4444" }, // red - priority
  { label: "MEDIUM",   color: "#f59e0b" }, // amber
  { label: "LOW",      color: "#10b981" }, // green
  { label: "URGENT",   color: "#dc2626" },
  { label: "DEV",      color: "#3b82f6" },
];

// A small color set used to consistently color user avatars.
const AVATAR_COLORS = ["#ef4444","#f97316","#f59e0b","#84cc16","#10b981","#14b8a6","#06b6d4","#3b82f6","#6366f1","#8b5cf6","#ec4899","#f43f5e"];

export function avatarColorFor(seed = "") {
  let h = 0;
  for (let i = 0; i < seed.length; i++) h = (h * 31 + seed.charCodeAt(i)) >>> 0;
  return AVATAR_COLORS[h % AVATAR_COLORS.length];
}

export function initialsFor(name = "") {
  const s = (name || "").trim();
  if (!s) return "?";
  const bits = s.replace(/@.*/, "").split(/[\s._-]+/).filter(Boolean);
  return ((bits[0]?.[0] || "") + (bits[1]?.[0] || "")).toUpperCase() || s[0].toUpperCase();
}

// Accent bar colors displayed at the bottom of every task card in the template.
export const CARD_ACCENTS = ["#3b82f6", "#84cc16", "#f59e0b", "#ec4899", "#8b5cf6"];

// Order of statuses shown in analytics breakdown
export const STATUS_LABELS = {
  todo: "To Do",
  doing: "Doing",
  done: "Done",
  backlog: "Back Log",
  yet_to_start: "Yet To Start",
  in_progress: "In Progress",
  on_hold: "On Hold",
  completed: "Completed",
  design: "Design",
  testing: "Testing",
};

export const STATUS_DOTS = {
  todo: "#f97316",
  yet_to_start: "#84cc16",
  in_progress: "#1e40af",
  on_hold: "#c026d3",
  completed: "#15803d",
  done: "#10b981",
  doing: "#3b82f6",
  backlog: "#6366f1",
  design: "#8b5cf6",
  testing: "#ec4899",
};
